import React, { useEffect, useState } from "react";

interface TextIrisModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AI_API_URL = process.env.REACT_APP_AI_API_URL;

export const TextIrisModal: React.FC<TextIrisModalProps> = ({ isOpen, onClose }) => {
  const [selectedDays, setSelectedDays] = useState(7);
  const [selectedChannel, setSelectedChannel] = useState("all");
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);


  const [availableChannels, setAvailableChannels] = useState<{ hls_url: string; name: string }[]>([]);

  const DUMMY_TEXT_DATA = {
    all: {
      1: { total: 89, avg_len: 142.5, avg_len_human: "143 chars", history: [["2024-01-20", 89]] },
      7: { 
        total: 623, 
        avg_len: 156.3, 
        avg_len_human: "156 chars", 
        history: [
          ["2024-01-14", 78],
          ["2024-01-15", 95],
          ["2024-01-16", 82],
          ["2024-01-17", 104],
          ["2024-01-18", 67],
          ["2024-01-19", 108],
          ["2024-01-20", 89]
        ]
      },
      14: { 
        total: 1234, 
        avg_len: 149.7, 
        avg_len_human: "150 chars", 
        history: [
          ["2024-01-07", 91], ["2024-01-08", 85], ["2024-01-09", 97], ["2024-01-10", 112], 
          ["2024-01-11", 73], ["2024-01-12", 88], ["2024-01-13", 103], ["2024-01-14", 78],
          ["2024-01-15", 95], ["2024-01-16", 82], ["2024-01-17", 104], ["2024-01-18", 67],
          ["2024-01-19", 108], ["2024-01-20", 89]
        ]
      },
      30: { 
        total: 2891, 
        avg_len: 153.2, 
        avg_len_human: "153 chars", 
        history: [
          ["2024-01-01", 89], ["2024-01-02", 92], ["2024-01-03", 76], ["2024-01-04", 105],
          ["2024-01-05", 68], ["2024-01-06", 98], ["2024-01-07", 91], ["2024-01-08", 85],
          ["2024-01-09", 97], ["2024-01-10", 112], ["2024-01-11", 73], ["2024-01-12", 88],
          ["2024-01-13", 103], ["2024-01-14", 78], ["2024-01-15", 95], ["2024-01-16", 82],
          ["2024-01-17", 104], ["2024-01-18", 67], ["2024-01-19", 108], ["2024-01-20", 89],
          ["2024-01-21", 94], ["2024-01-22", 80], ["2024-01-23", 101], ["2024-01-24", 115],
          ["2024-01-25", 71], ["2024-01-26", 99], ["2024-01-27", 86], ["2024-01-28", 93],
          ["2024-01-29", 83], ["2024-01-30", 102]
        ]
      }
    },
    bloombergtvplus: {
      1: { total: 34, avg_len: 167.2, avg_len_human: "167 chars", history: [["2024-01-20", 34]] },
      7: { 
        total: 243, 
        avg_len: 172.8, 
        avg_len_human: "173 chars", 
        history: [
          ["2024-01-14", 29],
          ["2024-01-15", 38],
          ["2024-01-16", 31],
          ["2024-01-17", 42],
          ["2024-01-18", 25],
          ["2024-01-19", 44],
          ["2024-01-20", 34]
        ]
      },
      14: { 
        total: 487, 
        avg_len: 169.4, 
        avg_len_human: "169 chars", 
        history: [
          ["2024-01-07", 36], ["2024-01-08", 32], ["2024-01-09", 39], ["2024-01-10", 45], 
          ["2024-01-11", 28], ["2024-01-12", 35], ["2024-01-13", 41], ["2024-01-14", 29],
          ["2024-01-15", 38], ["2024-01-16", 31], ["2024-01-17", 42], ["2024-01-18", 25],
          ["2024-01-19", 44], ["2024-01-20", 34]
        ]
      },
      30: { 
        total: 1034, 
        avg_len: 171.6, 
        avg_len_human: "172 chars", 
        history: [
          ["2024-01-01", 33], ["2024-01-02", 37], ["2024-01-03", 28], ["2024-01-04", 43],
          ["2024-01-05", 26], ["2024-01-06", 40], ["2024-01-07", 36], ["2024-01-08", 32],
          ["2024-01-09", 39], ["2024-01-10", 45], ["2024-01-11", 28], ["2024-01-12", 35],
          ["2024-01-13", 41], ["2024-01-14", 29], ["2024-01-15", 38], ["2024-01-16", 31],
          ["2024-01-17", 42], ["2024-01-18", 25], ["2024-01-19", 44], ["2024-01-20", 34],
          ["2024-01-21", 37], ["2024-01-22", 30], ["2024-01-23", 41], ["2024-01-24", 46],
          ["2024-01-25", 27], ["2024-01-26", 39], ["2024-01-27", 33], ["2024-01-28", 38],
          ["2024-01-29", 31], ["2024-01-30", 40]
        ]
      }
    }
  };

  const [hoveredBar, setHoveredBar] = useState<{index: number, count: number, date: string} | null>(null);

//   useEffect(() => {
//     if (isOpen) {
//       setLoading(true);
//       setTimeout(() => {
//         const channelData = DUMMY_TEXT_DATA[selectedChannel as keyof typeof DUMMY_TEXT_DATA];
//         setData(channelData[selectedDays as keyof typeof channelData]);
//         setLoading(false);
//       }, 800);
//     }
//   }, [isOpen, selectedDays, selectedChannel]);

    useEffect(() => {
    const controller = new AbortController();

    const loadChannels = async () => {
        try {
        const res = await fetch(`${AI_API_URL}/active-channels`, {
            signal: controller.signal,
        });
        if (!res.ok) throw new Error("Failed to load channels");
        const json = await res.json();
        setAvailableChannels(json.channels || []);
        } catch (e) {
        if ((e as any).name !== "AbortError") {
            console.error("Error fetching active channels:", e);
        }
        }
    };

    loadChannels();
    return () => controller.abort();
    }, []);


    useEffect(() => {
    if (!isOpen) {
        return () => {};
    }

    const controller = new AbortController();
    setLoading(true);

    const channelParam = selectedChannel === "all" ? "all" : encodeURIComponent(selectedChannel);

    fetch(
        `${AI_API_URL}/fetch-text-iris-stats?days=${selectedDays}&channel=${channelParam}`,
        { signal: controller.signal }
    )
        .then((r) => {
        if (!r.ok) throw new Error("Text-Iris fetch failed");
        return r.json();
        })
        .then((json) => setData(json))
        .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
        })
        .finally(() => setLoading(false));

    return () => controller.abort();
    }, [isOpen, selectedDays, selectedChannel]);

  const maxValue = data ? Math.max(...data.history.map((item: any) => item[1])) : 0;

  if (!isOpen) return null;

  return (
    <div
      role="presentation"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(4px)",
        animation: isOpen ? "fadeIn 0.3s ease-out" : "fadeOut 0.3s ease-out",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          onClose();
        }
      }}
      tabIndex={-1}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(20px)",
          borderRadius: "20px",
          padding: "32px",
          width: "90%",
          maxWidth: "800px",
          maxHeight: "90vh",
          overflowY: "auto",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
          animation: isOpen ? "zoomIn 0.4s cubic-bezier(0.4, 0, 0.2, 1)" : "",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "32px" }}>
          <div>
            <h2 style={{ color: "#ffffff", fontSize: "24px", fontWeight: "700", margin: 0 }}>
              Text Iris Analytics
            </h2>
            <p style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px", margin: "4px 0 0 0" }}>
              Conversation starts and interaction analysis
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              color: "#ffffff",
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            ✕
          </button>
        </div>

        {/* Controls */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
          {/* Time Period Selector */}
          <div>
            <p style={{ margin: 0, marginBottom: 8, color: "rgba(255, 255, 255, 0.8)", fontSize: 14, fontWeight: 500 }}>
              Time Period
            </p>
            <select
              id="text-period"
              aria-label="Time period"
              value={selectedDays}
              onChange={(e) => setSelectedDays(Number(e.target.value))}
              style={{
                display: "block",
                width: "100%",
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 8,
                color: "#ffffff",
                padding: "8px 12px",
                fontSize: 14,
                outline: "none",
              }}
            >
              <option value={1} style={{ background: "#1f2937", color: "#ffffff" }}>Last 24 hours</option>
              <option value={7} style={{ background: "#1f2937", color: "#ffffff" }}>Last 7 days</option>
              <option value={14} style={{ background: "#1f2937", color: "#ffffff" }}>Last 14 days</option>
              <option value={30} style={{ background: "#1f2937", color: "#ffffff" }}>Last 30 days</option>
            </select>
          </div>

          {/* Channel Selector */}
          <div>
            <p style={{ margin: 0, marginBottom: 8, color: "rgba(255, 255, 255, 0.8)", fontSize: 14, fontWeight: 500 }}>
              Channel
            </p>
            <select
            id="text-channel"
            aria-label="Channel"
            value={selectedChannel}
            onChange={(e) => setSelectedChannel(e.target.value)}
            style={{
                display: "block",
                width: "100%",
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 8,
                color: "#ffffff",
                padding: "8px 12px",
                fontSize: 14,
                outline: "none",
            }}
            >
            <option value="all" style={{ background: "#1f2937", color: "#ffffff" }}>
                All Channels
            </option>
            {availableChannels.map((ch) => (
                <option
                key={ch.name}
                value={ch.name}
                style={{ background: "#1f2937", color: "#ffffff" }}
                >
                {ch.name}
                </option>
            ))}
            </select>
          </div>
        </div>

        {/* Chart */}
        <div style={{ marginBottom: "32px" }}>
          <h3 style={{ color: "#ffffff", fontSize: "18px", fontWeight: "600", marginBottom: "16px" }}>
            Daily Conversation Starts {selectedChannel !== "all" && `- ${selectedChannel}`}
          </h3>
          <div
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "12px",
              padding: "24px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              height: "300px",
              display: "flex",
              position: "relative",
            }}
          >
            {loading ? (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", color: "rgba(255, 255, 255, 0.7)" }}>
                Loading chart...
              </div>
            ) : (
              <>
                {/* Y-Axis */}
                <div
                  style={{
                    width: "50px",
                    height: "240px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    paddingRight: "12px",
                    marginRight: "16px",
                    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
                  }}
                >
                  {[...Array(6)].map((_, i) => {
                    const value = Math.round((maxValue * (5 - i)) / 5);
                    return (
                      <div
                        key={i}
                        style={{
                          color: "rgba(255, 255, 255, 0.6)",
                          fontSize: "11px",
                          fontWeight: "500",
                          textAlign: "right",
                          lineHeight: "1",
                        }}
                      >
                        {value > 0 ? value : 0}
                      </div>
                    );
                  })}
                </div>

                {/* Chart Area */}
                <div
                  style={{
                    flex: 1,
                    height: "240px",
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "space-around",
                    gap: "4px",
                    position: "relative",
                  }}
                >
                  {/* Horizontal grid lines */}
                  {[...Array(6)].map((_, i) => (
                    <div
                      key={i}
                      style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: `${(i * 240) / 5}px`,
                        height: "1px",
                        background: "rgba(255, 255, 255, 0.05)",
                        pointerEvents: "none",
                      }}
                    />
                  ))}

                  {/* Bars */}
                    {data?.history.map((item: any, index: number) => {
                    const [date, count] = item;
                    const height = (count / maxValue) * 240;

                    return (
                        <div
                        key={date}
                        style={{
                            position: "relative",
                            flex: 1,
                            height: "100%",
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: "center",
                        }}
                        >
                        <div
                            style={{
                            height: `${height}px`,
                            width: "100%",
                            maxWidth: 40,
                            background: "linear-gradient(to top, #8b5cf6, #a78bfa)",
                            borderRadius: "4px 4px 0 0",
                            boxShadow: "0 4px 12px rgba(139,92,246,0.3)",
                            animation: `barGrowUp 1s ease-out ${index * 0.1}s both`,
                            cursor: "pointer",
                            }}
                            onMouseEnter={() => setHoveredBar({ index, count, date })}
                            onMouseLeave={() => setHoveredBar(null)}
                        />

                        {hoveredBar?.index === index && (
                            <div
                            style={{
                                position: "absolute",
                                bottom: `${height + 10}px`,
                                left: "50%",
                                transform: "translateX(-50%)",
                                background: "rgba(0,0,0,.8)",
                                color: "#a78bfa",
                                padding: "4px 8px",
                                borderRadius: 4,
                                fontSize: 12,
                                fontWeight: 600,
                                pointerEvents: "none",
                            }}
                            >
                            {count}
                            </div>
                        )}

                        <div
                            style={{
                            position: "absolute",
                            bottom: -18,
                            left: "50%",
                            transform: "translateX(-50%)",
                            color: "rgba(255,255,255,.6)",
                            fontSize: 10,
                            lineHeight: 1.2,
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            }}
                        >
                            {new Date(date).toLocaleDateString([], { month: "short", day: "numeric" })}
                        </div>
                        </div>
                    );
                    })}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Summary Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          <div
            style={{
              background: "rgba(255, 255, 255, 0.08)",
              borderRadius: "12px",
              padding: "20px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              textAlign: "center",
            }}
          >
            <div style={{ color: "#a78bfa", fontSize: "28px", fontWeight: "700", marginBottom: "4px" }}>
              {data?.total.toLocaleString() || 0}
            </div>
            <div style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px" }}>Total Conversations</div>
          </div>
          <div
            style={{
              background: "rgba(255, 255, 255, 0.08)",
              borderRadius: "12px",
              padding: "20px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              textAlign: "center",
            }}
          >
            <div style={{ color: "#a78bfa", fontSize: "28px", fontWeight: "700", marginBottom: "4px" }}>
              {data?.avg_msgs_human || "—"}
            </div>
            <div style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px" }}>Avg Conv Length</div>
          </div>
        </div>
      </div>
    </div>
  );
}